import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";

import * as serviceWorker from "./serviceWorker";
import App from "./app/App";

// third party style
import "perfect-scrollbar/css/perfect-scrollbar.css";
// const express=require('express');
// var app=express();
// const apiRoutes = require("../src/api");
//  app.use("/api",apiRoutes);
const root = createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <App />
  </HashRouter>
);

serviceWorker.unregister();
